// extracted by mini-css-extract-plugin
export var arrows = "_68-5";
export var decrementer = "_68-9";
export var disabled = "_68-3";
export var error = "_68-1";
export var hiddenText = "_68-a";
export var incrementer = "_68-8";
export var input = "_68-7";
export var inputWrapper = "_68-0";
export var leadingIcon = "_68-b";
export var readonly = "_68-2";
export var regular = "_68-6";
export var small = "_68-4";